import { SelectProps } from "@cloudscape-design/components";
import AppConfig from "configs/AppConfig";

export type DeploymentType = "shared" | "dedicated";

export interface DeploymentItem {
  id: string;
  org_id: string;
  name: string;
  region: string;
  domainName?: string;
  organizationId?:string;
  status: string;
  console_url: string;
  users: string;
  sessions: string;
  idps: string;
  health: boolean | string; // Temporary (change to boolean)
  creator_id: string;
  payment_status?: PaymentStatus;
  version: string;
  created_at: string;
}

interface PaymentStatus{
  status: string;
  plan: "develop" | "scale" | "accelerate";
  billing_type: "monthly" | "yearly";
  size: "small" | "medium" | "large";
}

export interface DeploymentData {
  region: SelectProps.Option | null;
  name: string;
  organizationId: SelectProps.Option | null;
  domainName: string;
  hostedZoneId: string;
  deploymentPlan: string; // "develop" or "scale" or "accelerate"
  billingCycle: string;
  keycloakVersion: SelectProps.Option | null;
  clusterSize: string; // "small" or "medium" or "large"
  useAlb: boolean;
  errors: {
    region?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    domainName?: string;
    deploymentPlan?: string;
    billingCycle?: string;
    keycloakVersion?: string;
    clusterSize?: string;
  };
}

export interface ValidationResultSharedCluster {
  isValid: boolean;
  errors?: DeploymentData["errors"];
  validData?: {
    region: string;
    name: string;
    organizationId: string;
  };
}

export interface ValidationResultDedicatedCluster {
  isValid: boolean;
  errors?: DeploymentData["errors"];
  validData?: {
    region: string;
    name: string;
    deploymentPlan: string;
    billingCycle: string;
    domainName: string;
    organizationId: string;
    subscriptionId: string;
    keycloakVersion: string;
  };
}

export const initialDeploymentState: DeploymentData = {
  region: null,
  name: "",
  deploymentPlan: "develop", // default
  billingCycle: "monthly", // default
  organizationId: null,
  domainName: "",
  hostedZoneId: AppConfig.DEFAULT_HOSTED_ZONE_ID ?? "",
  keycloakVersion: null,
  clusterSize: "small", // default
  useAlb: false,
  errors: {},
} as const;

export interface SharedDeploymentsTableProps {
  columnDefinitions: any[];
  deploymentType: "shared" | "dedicated";
  columnDisplayOrder: any[];
  deploymentsList: DeploymentItem[];
  isLoadingDeployments: boolean;
  loadingDeploymentsError: string | null;
}